import { updateYear, updateMonth } from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";

export const useManualUploadsYearMonthFilters = () => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector(
    (state) => state.manualUploadsYearMonthFilters
  );

  return {
    manualUploadsYearMonthFilters: selector,
    updateYear: (payload: number) => dispatch(updateYear(payload)),
    updateMonth: (payload: string) => dispatch(updateMonth(payload)),
  };
};
